import * as React from 'react';
import { ThemeFactory } from '@theme/ThemeFactory';
import { ULTheme } from '@theme/types';
import { WhitelabelContext } from '@whitelabel/WhitelabelContext';
import { WhitelabelFactory } from '@whitelabel/WhitelabelFactory';
import { WhitelabelId } from '@whitelabel/WhitelabelId';
import { WhitelabelConfig } from '@whitelabel/types';
import { ThemeProvider } from 'styled-components';
import { Helmet } from 'react-helmet';
import { useAppContext } from '@contexts/app/hooks/useAppContext';

type WhitelabelAwareProps = {
    whitelabelId: WhitelabelId;
    cultureCode: string;
};

export const WhitelabelAware: React.FC<WhitelabelAwareProps> = React.memo(props => {
    const wlConfig: WhitelabelConfig = WhitelabelFactory.getConfig(props.whitelabelId);
    const { appId } = useAppContext();
    const theme: ULTheme = ThemeFactory.getTheme(props.whitelabelId, props.cultureCode, appId);

    return (
        <>
            <Helmet>
                <title>{wlConfig.displayName}</title>
                <link rel="icon" href={theme.faviconUrl} />
            </Helmet>
            <WhitelabelContext.Provider value={wlConfig}>
                <ThemeProvider theme={theme}>{props.children}</ThemeProvider>
            </WhitelabelContext.Provider>
        </>
    );
});
WhitelabelAware.displayName = 'WhitelabelAware';
